import bem from 'utils/bem';

export const block = bem('text-toolbar');
export const textControlsBlock = bem('text-controls');
